import React from 'react';
import { compose, setPropTypes } from 'recompose';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { get, includes } from 'lodash';
import UploadButton from '../atoms/UploadButton';
import ClearButton from '../atoms/ClearButton';

const styles = theme => ({
  inputLabel: {
    display: 'inline !important'
  },
  input: {
    display: 'none'
  },
  image: {
    width: '300px',
    margin: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '5px 0'
    }
  },
  previewCard: {
    minHeight: 400
  }
});

const validMineType = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf'
];

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(
  ({
    classes,
    label,
    setFile,
    setPreviewImage,
    indexNumber,
    type,
    setType,
    previewImage,
    largePreview
  }) => {
    const imagePreview = preview => {
      const reader = new FileReader();
      reader.readAsDataURL(preview);
      reader.onloadend = () => {
        setPreviewImage(reader.result, indexNumber);
      };
    };

    const handleOnChange = e => {
      const newFile = e.target.files[0];
      const mineFile = get(newFile, 'type', '');
      if (includes(validMineType, mineFile)) {
        setFile(newFile, indexNumber);
        setType(mineFile, indexNumber);
        imagePreview(newFile, indexNumber);
      } else {
        alert('画像の形式が正しくありま線。');
      }
      e.target.value = null;
    };

    return (
      <div>
        <InputLabel
          htmlFor={label}
          margin="dense"
          className={classes.inputLabel}
        >
          <UploadButton />
          <ClearButton
            onClickAction={() => {
              setFile(null, indexNumber);
              setPreviewImage(null, indexNumber);
            }}
          />
        </InputLabel>
        {previewImage && (
          <Card className={classes.image}>
            <CardActionArea>
              {type === 'application/pdf' ? (
                // eslint-disable-next-line jsx-a11y/alt-text
                <object
                  className={largePreview ? classes.previewCard : ''}
                  data={previewImage}
                  type="application/pdf"
                  width="100%"
                  height="100%"
                />
              ) : (
                <CardMedia component="img" image={previewImage} />
              )}
            </CardActionArea>
          </Card>
        )}

        <input
          id={label}
          type="file"
          accept="image/jpeg,image/png,application/pdf"
          className={classes.input}
          onChange={e => handleOnChange(e)}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
